import { instantCash as AT } from './AT';
import { instantCash as CZ } from './CZ';
import { instantCash as HR } from './HR';
import { instantCash as HU } from './HU';
import { instantCash as RO } from './RO';
import { instantCash as SK } from './SK';
import { instantCash as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
